export class EncryptionUtil {
  private static readonly SECRET_KEY = 'HUB_MEDICAL_2024'; // Mude para algo único

  static encrypt(text: string): string {
    try {
      // Adiciona o secret key antes de encodar
      const combined = `${this.SECRET_KEY}::${text}`;
      return btoa(encodeURIComponent(combined));
    } catch (e) {
      console.error('Erro ao encriptar:', e);
      return '';
    }
  }

  static decrypt(encodedText: string): string | null {
    try {
      const decoded = decodeURIComponent(atob(encodedText));
      const [key, value] = decoded.split('::');
      
      // Valida se tem o secret key correto
      if (key !== this.SECRET_KEY) {
        console.warn('Secret key inválido');
        return null;
      }
      
      return value;
    } catch (e) {
      console.error('Erro ao decriptar:', e);
      return null;
    }
  }
}
